<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="navigation" />
      <d-col class="main-content mb-4 offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">
        <!-- Main blue navbart -->
        <Notifications/>
      </d-col>
      <d-col class="main-content mb-4 offset-lg-2 offset-md-3 p-0 mt-5" tag="main" lg="10" md="9" sm="12">
        <!-- Content -->
        <slot/>
      </d-col>
    </d-row>
  </d-container>
</template>
<script>
import MainSidebar from '@/components/layout/MainSidebar.vue';
import Notifications from '@/components/others/Notifications.vue';

export default {
  name: 'main-view',
  components: {
    MainSidebar,
    Notifications
  },
  data() {
    return {
      navigation: [],
      sidebarItems: [
        {
          title: 'Strona główna',
          to: '/kokpit',
          htmlBefore: '<i class="material-icons">home</i>',
          visible: () => this.accountPermissions.home ? this.accountPermissions.home : 0
        },
        {
          title: 'Pacjenci',
          to: '/pacjenci',
          htmlBefore: '<i class="material-icons">people</i>',
          visible: () => this.accountPermissions.patients ? this.accountPermissions.patients : 0
        },
        {
          title: 'Listy rezerwowe',
          htmlBefore: '<i class="material-icons">terrain</i>',
          visible: () => this.accountPermissions.reservation_list ? this.accountPermissions.reservation_list : 0,
          items: [
            {
              title: 'Nowe wizyty',
              to: '/reservation_list/nowe-wizyty',
              visible: () => this.accountPermissions.reservation_list ? this.accountPermissions.reservation_list : 0,
            },
            {
              title: 'Kontynuacje wizyt',
              to: '/reservation_list/kontynuacje-wizyty',
              visible: () => this.accountPermissions.reservation_list ? this.accountPermissions.reservation_list : 0,
            }
          ],
        },
        {
          title: 'Wizyty',
          to: '/wizyty',
          htmlBefore: '<i class="material-icons">date_range</i>',
          visible: () => this.accountPermissions.visits ? this.accountPermissions.visits : 0
        },
        {
          title: 'Urlopy',
          htmlBefore: '<i class="material-icons">update</i>',
          visible: () => this.accountPermissions.holidays ? this.accountPermissions.holidays : 0,
          items: [
            {
              title: 'Moje urlopy',
              to: '/urlopy',
              visible: () => this.accountPermissions.my_holidays ? this.accountPermissions.my_holidays : 0
            },
            {
              title: 'Moje plany urlopowe',
              to: '/plany-urlopowe',
              visible: () => this.accountPermissions.my_holidays_plans ? this.accountPermissions.my_holidays_plans : 0
            },
            {
              title: 'Plany urlopowe innych',
              to: '/plany-urlopowe-innych',
              visible: () => this.accountPermissions.others_holidays_plans ? this.accountPermissions.others_holidays_plans : 0
            },
          ],
        },
        {
          title: 'Urlopy moich pracowników',
          htmlBefore: '<i class="material-icons">terrain</i>',
          visible: () => this.accountPermissions.children_holidays_tab ? this.accountPermissions.children_holidays_tab : 0,
          items: [
            {
              title: 'Urlopy moich pracowników',
              to: '/urlopy-pracownikow',
              visible: () => this.accountPermissions.children_holidays ? this.accountPermissions.children_holidays : 0,
            },
            {
              title: 'Plany urlopowe moich pracowników',
              to: '/plany-urlopowe-pracownikow',
              visible: () => this.accountPermissions.children_holidays_plans ? this.accountPermissions.children_holidays_plans : 0,
            }
          ],
        },
        {
          title: 'System',
          htmlBefore: '<i class="material-icons">settings</i>',
          visible: () => this.accountPermissions.system ? this.accountPermissions.system : 0,
          items: [
            {
              title: 'Użytkownicy',
              to: '/uzytkownicy',
              visible: () => this.accountPermissions.system_users ? this.accountPermissions.system_users : 0
            },
            {
              title: 'Placówki',
              to: '/placowki',
              visible: () => this.accountPermissions.system_institutions ? this.accountPermissions.system_institutions : 0
            },
            {
              title: 'Gabinety',
              to: '/gabinety',
              visible: () => this.accountPermissions.system_offices ? this.accountPermissions.system_offices : 0
            },
            {
              title: 'Usługi',
              to: '/usługi',
              visible: () => this.accountPermissions.system_services ? this.accountPermissions.system_services : 0
            },
            {
              title: 'Kategorie usług',
              to: '/kategorie',
              visible: () => this.accountPermissions.system_services ? this.accountPermissions.system_services : 0
            },
            {
              title: 'Badania lekarskie',
              to: '/badania',
              htmlBefore: '<i class="material-icons">biotech</i>',
              visible: () => this.accountPermissions.system_medical_examinations ? this.accountPermissions.system_medical_examinations : 0
            },
            {
              title: 'Dokumenty elektroniczne',
              to: '/dokumenty-elektroniczne',
              htmlBefore: '<i class="material-icons">add_to_queue</i>',
              visible: () => this.accountPermissions.system_edocuments ? this.accountPermissions.system_edocuments : 0
            },
            {
              title: 'Kategorie dokumentów elektronicznych',
              to: '/kategorie-dokumentow-elektronicznych',
              htmlBefore: '<i class="material-icons">add_to_queue</i>',
              visible: () => this.accountPermissions.system_edocuments ? this.accountPermissions.system_edocuments : 0
            },
            {
              title: 'Reguły pracy',
              to: '/reguly',
              htmlBefore: '<i class="material-icons">settings_accessibility</i>',
              visible: () => this.accountPermissions.system_edocuments ? this.accountPermissions.system_edocuments : 0
            },
            {
              title: 'Raport SIO',
              to: '/report-sio',
              visible: () => this.accountPermissions.system_sio_report ? this.accountPermissions.system_sio_report : 0
            },
            {
              title: 'Raport pracy',
              to: '/raporty-pracy',
              visible: () => this.accountPermissions.system_work_report ? this.accountPermissions.system_work_report : 0
            },
            {
              title: 'Export uczniów',
              to: '/export-uczniow',
              visible: () => this.accountPermissions.system_patients_report ? this.accountPermissions.system_patients_report : 0
            },
          ],
        },
        {
          title: 'Regulaminy',
          to: '/regulaminy',
          htmlBefore: '<i class="material-icons">text_snippet</i>',
          visible: () => this.accountPermissions.home ? this.accountPermissions.home : 0
        },
      ],
    };
  },
  computed: {
    accountPermissions () {
      return this.$store.getters.getAccountPermissions
    }
  },
  created() {
    new Promise(() => {
      this.userAccountGet()
    })
  },
  mounted() {
    new Promise(() => {
      this.newMenuList()
    })
  },
  methods: {
    newMenuList() {
      this.navigation = this.sidebarItems
    },
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
  },
};
</script>

